module.exports = __webpack_public_path__ + "images/modern-e6046d7c428400eca840a93f292ec6c2.jpg";